import { IsArray, IsEnum } from 'class-validator';
import { DayOfWeek } from '../cleaning-area/day-of-week.enum';

export class UpdateWeeklyClosureDaysDto {
  @IsArray()
  @IsEnum(DayOfWeek, { each: true })
  weeklyClosureDays!: DayOfWeek[];
}
